(() => {
  class Header {
    constructor() {
      this.els();
      this.listeners();
    }

    els() {
      this.$breakpoint = window.matchMedia('(min-width: 768px)');
      this.$html = document.documentElement;
      this.$hoverElements = document.querySelectorAll('[data-nav-hover]');
      this.$desktopNavItem = document.querySelectorAll('.desktop-nav__item');
      this.$nav = document.querySelector('#nav');
      this.$navClose = document.querySelector('#mobileMenuClose');
      this.$navToggle = document.querySelector('#navSummary');
    };

    listeners() {
      /* Open mobile menu */
      this.$navToggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.$html.classList.toggle('mobile-menu--transition');
        this.$html.classList.toggle('mobile-menu--active');
        this.$nav.setAttribute('aria-hidden', 'false');
        this.$navToggle.setAttribute('aria-expanded', 'true');

        setTimeout(() => {
          this.$nav.focus();
          this.trapFocus(this.$nav);
        }, 50);

        setTimeout(() => {
          this.$html.classList.remove('mobile-menu--transition');
        }, 300);
      });

      /* Close mobile menu */
      this.$navClose.addEventListener('click', (e) => {
        e.preventDefault();
        this.$html.classList.add('mobile-menu--transition');
        this.$html.classList.toggle('mobile-menu--active');
        this.$nav.setAttribute('aria-hidden', 'true');
        this.$navToggle.setAttribute('aria-expanded', 'false');

        setTimeout(() => {
          this.$html.classList.remove('mobile-menu--transition');
          if (window.searchMenuQueryMobileNav) window.searchMenuQueryMobileNav.value = '';
        }, 300);
      });

      /* Desktop */
      this.$hoverElements.forEach((hoverElement) => {
        const link = hoverElement.querySelector('[data-nav-hover-link]');
        const submenu = hoverElement.querySelector('[data-subnav]');

        if (link && submenu) {
          hoverElement.addEventListener('touchstart', (e) => {
            if (this.$breakpoint.matches && e.target.matches('[data-nav-hover-link]')) {
              e.preventDefault();
              const siblings = Array.from(e.target.parentNode.parentNode.children);
              const index = siblings.findIndex(child => {
                return child.classList.contains('hover');
              });

              if (index >= 0 && e.target.parentNode != siblings[index]) {
                this.$html.classList.remove('header-hover');
                siblings[index].classList.remove('hover');
                link.setAttribute('aria-expanded', 'false');
              }

              this.$html.classList.toggle('header-hover');
              hoverElement.classList.toggle('hover');
              link.setAttribute('aria-expanded', `${(link.getAttribute('aria-expanded') !== 'true').toString()}`);
            }
          });

          hoverElement.addEventListener('mouseenter', () => {
            if (this.$breakpoint.matches) {
              this.$html.classList.add('header-hover');
              hoverElement.classList.add('hover');
              link.setAttribute('aria-expanded', 'true');
            }
          });

          hoverElement.addEventListener('mouseleave', () => {
            if (this.$breakpoint.matches) {
              this.$html.classList.remove('header-hover');
              if (hoverElement.classList.contains('hover')) {
                hoverElement.classList.remove('hover');
              }
              link.setAttribute('aria-expanded', 'false');
            }
          });
        }
      })

      this.$desktopNavItem.forEach((hoverElement) => {
        hoverElement.addEventListener('mouseenter', () => {
          hoverElement.classList.add('is-hover');
          this.$html.classList.add('desktop-header-hover');
        })

        hoverElement.addEventListener('mouseleave', () => {
          hoverElement.classList.remove('is-hover');
          this.$html.classList.remove('desktop-header-hover');
        })
      });

      /* Desktop */
      document.addEventListener('touchstart', (e) => {
        if (this.$breakpoint.matches) {
          if (document.querySelector('.hover') && !e.target.closest('[data-nav-hover]')) {
            const activeSibling = document.querySelector('[data-nav-hover].hover');
            this.$html.classList.remove('header-hover');
            activeSibling.classList.remove('hover');
            activeSibling.querySelector('[data-nav-hover-link]').setAttribute('aria-expanded', 'false');
          }
        }
      });

      /* Desktop */
      document.addEventListener('keydown', (e) => {
        const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        if (this.$breakpoint.matches) {
          if (isTabPressed && e.target.matches('[data-nav-hover-link]')) {
            const hoverElement = e.target.closest('[data-nav-hover]');

            if (e.shiftKey) {
              hoverElement.dispatchEvent(new Event('mouseleave', { bubbles: true }));
            } else {
              hoverElement.dispatchEvent(new Event('mouseenter', { bubbles: true }));
            }
          }

          if (e.key === 'Escape') {
            const hoverElement = document.querySelector('[data-nav-hover].hover');
            if (hoverElement) {
              hoverElement.dispatchEvent(new Event('mouseleave', { bubbles: true }));
            }
          }
        }
      });

      document.addEventListener('keyup', (e) => {
        /* Desktop */
        if (this.$breakpoint.matches) {
          if (e.target.matches('[data-nav-hover-link]')) {
            const hoverElement = e.target.closest('[data-nav-hover]');
            hoverElement.dispatchEvent(new Event('mouseleave', { bubbles: true }));
          }

          if (e.target.matches('.nav__link')) {
            const hoverElement = document.querySelector('[data-nav-hover].hover');
            if (hoverElement) {
              hoverElement.focus();
              hoverElement.dispatchEvent(new Event('mouseleave', { bubbles: true }));
            }
          }
        }

        /* Mobile */
        if (e.key === 'Escape') {
          if (this.$html.classList.contains('mobile-menu--active')) {
            const menus = document.querySelectorAll('[data-nav-dropdown].active');

            this.$navClose.click();

            if (menus.length) {
              setTimeout(() => {
                menus.forEach((menu) => {
                  menu.classList.remove('active');
                });
              }, 300);
            }
            this.$navToggle.focus();
          }
        }
      });

      document.addEventListener('click', (e) => {
        if (!this.$breakpoint.matches) {
          /* Open mobile sub menu */
          if (e.target.matches('[data-nav-menu-toggle]')) {
            const id = e.target.getAttribute('data-nav-menu-toggle');
            const menu = document.querySelector(`#${id}`);
            if (menu) {
              e.preventDefault();
              menu.classList.add('active');

              setTimeout(() => {
                menu.focus();
                this.trapFocus(menu);
              }, 50);
            }
          }

          /* Close mobile sub menu */
          if (e.target.matches('[data-nav-menu-back]')) {
            const id = e.target.getAttribute('data-nav-menu-back');
            const menu = document.querySelector(`#${id}`);
            if (menu) {
              e.preventDefault();
              menu.classList.add('transition');
              menu.classList.remove('active');

              setTimeout(() => {
                menu.classList.remove('transition');
              }, 300);
            }
          }

          /* Close mobilemenu and all sub menus */
          if (e.target.matches('[data-nav-menu-close]')) {
            const menus = document.querySelectorAll('[data-nav-dropdown].active');

            this.$navClose.click();

            if (menus.length) {
              e.preventDefault();

              setTimeout(() => {
                menus.forEach((menu) => {
                  menu.classList.remove('active');
                });
              }, 300);
            }
          }
        }
      });
    };

    trapFocus(modal) {
      document.addEventListener('keydown', (e) => {
        const focusableElements = 'button, [href], input, select, textarea'
        const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]
        const focusableContent = modal.querySelectorAll(focusableElements)
        const lastFocusableElement = focusableContent[focusableContent.length - 1]
        const isTabPressed = e.key === 'Tab' || e.keyCode === 9

        if (!isTabPressed) {
          return
        }

        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus()
            e.preventDefault()
          } else if (modal && document.activeElement === modal) {
            lastFocusableElement.focus()
            e.preventDefault()
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus()
            e.preventDefault()
          } else if (modal && document.activeElement === modal) {
            firstFocusableElement.focus()
            e.preventDefault()
          }
        }
      })
    };
  };

  new Header();
})();
